import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';

import { Content } from '../../../_models';
import {AuthenticationService, NotificationService, ContentService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentEpisode } from 'src/app/_models/content-episode';

@Component({
  selector: 'app-episode-detail',
  templateUrl: './episode-detail.component.html',
  styleUrls: []
})
export class EpisodeDetailComponent implements OnInit {

  episodeData: ContentEpisode = null;
  loaded = false;
  loading = true;
  processing = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private contentSvc: ContentService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.loadDetail(id);
  }


  save() {
    this.processing = true;
    if (confirm("Are you sure to update this episode?")) {
      this.contentSvc.updateEpisode(this.episodeData).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Episode updated successfully!", "Update Episode");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update episode, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/tx/content', this.episodeData.contentId, 'episode']);
  }

  private loadDetail(id){
    this.contentSvc.getEpisode(id).subscribe(data => {
      this.episodeData = data
      this.loaded = true;
      this.loading = false;
    });
  }
}
